import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

// Old addresses from the earlier site and app, kept working.
const MOVED = {
  "/explore": "/",
  "/home": "/",
  "/about/pricing": "/pricing",
  "/about/for-businesses": "/business",
  "/about/for-providers": "/business",
  "/about/careers": "/careers",
  "/about/payments": "/payments",
  "/about/blog": "/blog",
  "/legal/privacy-policy": "/legal/privacy",
  "/legal": "/legal/terms",
  "/become-partner": "/business#register",
};

function movedTo(path) {
  const p = path.replace(/\/+$/, "") || "/";
  if (MOVED[p]) return MOVED[p];
  const m = p.match(/^\/about\/blog\/([a-z0-9-]+)$/);
  return m ? `/blog/${m[1]}` : null;
}

/** Scroll to the top on page change, or to #anchor when the address has one. */
export function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
}

export function NotFound() {
  const { pathname } = useLocation();
  const target = movedTo(pathname);
  useEffect(() => {
    if (target) window.location.replace(target);
  }, [target]);
  if (target) return null;
  return (
    <div className="mx-auto max-w-xl px-6 py-24 text-center" data-testid="not-found">
      <h1 className="mb-3 font-serif-display text-3xl font-bold">We couldn't find that page</h1>
      <p className="mb-8 text-muted-foreground">It may have moved. Try the home page or explore what's on Fable +.</p>
      <div className="flex justify-center gap-6 font-medium">
        <Link to="/" className="underline underline-offset-4">Home</Link>
        <Link to="/marketplace" className="underline underline-offset-4">Marketplace</Link>
        <Link to="/travel" className="underline underline-offset-4">Travel</Link>
      </div>
    </div>
  );
}
